enum RenderMask {
  OPAQUE = 1 << 0,
  BLENDED = 1 << 1,
  ALL = 0x1fffffff,
}

export default RenderMask
